import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PayAway } from 'models';

@Injectable({
	providedIn: 'root',
})
export class PayAwayService {
	constructor(private http: HttpClient) {}

	public get(userId: string): Observable<PayAway[]> {
		return this.http.get<PayAway[]>(`api/payaway/get/${userId}`);
	}

	public save(userId: string, payAway: PayAway): Observable<null> {
		return this.http.post<null>(`api/payaway/save/${userId}`, payAway);
	}

	public update(userId: string, pricePlan: PayAway): Observable<null> {
		return this.http.put<null>(`api/payaway/update/${userId}`, pricePlan);
	}
}
